import { useEffect, useRef, useState } from 'react';

const useShowPopup = (id: string) => {
  const [isShown, setIsShown] = useState(false);
  const ref = useRef<ReturnType<typeof setTimeout>>();
  const hide = () => {
    setIsShown(false);
  };

  useEffect(() => {
    if (!ref.current) {
      ref.current = setTimeout(() => {
        setIsShown(true);
      }, 5000);
    }

    return () => {
      ref.current && clearTimeout(ref.current);
    };
  }, []);

  return { isShown, hide };
};

export default useShowPopup;
